import { createFileRoute } from "@tanstack/react-router";
import { SettingsGeneral } from "src/pages/Settings/SettingsGeneral";

export const Route = createFileRoute("/settings/general")({
	component: SettingsGeneral,
});
